const docIdFilter = function (value) {
  switch (value) {
    case "0":
      return "订单";
    case "1":
      return "结算单";
    case "2":
      return "发票";
    case "3":
      return "付款承诺";
    case "4":
      return "其他";
    case "5":
      return "票据";
    case "6":
      return "发货通知";
    case "10":
      return "保单";
    case "11":
      return "对账单";
    case "TCI":
      return "交强险";
    case "VCI":
      return "商业车险";
    default:
      return null;
  }
};
const GbCbmTrans = function (value) {
  switch (+value) {
    case 0:
    case "0":
      return "不可变更";
    case 1:
    case "1":
      return "可变更";
    case 2:
    case "2":
      return "已变更";
    case 3:
    case "3":
      return "待复核";
    default:
      return null;
  }
};
const GbGldStCdTrans = function (value) {
  value = String(value);
  switch (value) {
    case "0":
      return "待签收";
    case "1":
      return "已签收";
    case "2":
      return "已撤销";
    case "3":
      return "已拒绝";
    case "4":
      return "确认已拒绝";
    case "5":
      return "待确认";
    case "6":
      return "已结清";
    case "7":
      return "待复核";
    case "8":
      return "复核已拒绝";
    case '9':
      return '待担保';
    case '10':
      return '担保已拒绝';
    case '11':
      return '结算失败';
    default:
      return null;
  }
};
const GbGldStCdTrans2 = function (value) {
  switch (+value) {
    case 1:
      return "已同意";
    case 3:
      return "已拒绝";
    case 6:
      return "已同意";
    default:
      return null;
  }
};
const pledgeStatus = function (value) {
  switch (+value) {
    case 0:
      return "无质押";
    case 1:
      return "未质押";
    case 2:
      return "已质押";
    case 3:
      return "已拒绝";
    case 4:
      return "质押解除";
    default:
      return null;
  }
};

const getNameFormList = function (val, arr, prop = "key", valName = "name") {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][prop] == val) {
      return arr[i][valName];
    }
  }
  return "";
};
const goldTransferType = function (value) {
  switch (+value) {
    case 0:
      return "祺信开立";
    case 1:
      return "祺信支付";
    case 2:
      return "祺信融资";
    case 3:
      return "祺信质押";
    case 4:
      return "祺信解质";
    default:
      return null;
  }
};
const rpMdCdTrans = function (value) {
  switch (value) {
    case "0":
      return "利随本清";
    case "1":
      return "按月结息，到期还本";
    case "2":
      return "分期付款";
    case "3":
      return "等额本金";
    case "4":
      return "等额本息";
    case "5":
      return "初期付息，到期还本";
    case "6":
      return "按季结息，到期还本";
    default:
      return null;
  }
};

const reqCptlTpCdTrans = function (value) {
  switch (value) {
    case "0":
      return "支付货款";
    case "1":
      return "支付工资";
    case "2":
      return "其他";
    default:
      return value;
  }
};

const tranType = function (value) {
  switch (value) {
    case "BF":
      return "转账";
    case "TX":
      return "提现";
    case "BH":
      return "解冻支付";
    case "BS":
      return "支付冻结";
    case "BG":
      return "解冻";
    case "BR":
      return "冻结";
    default:
      return null;
  }
};
const signStCdTrans = function (value) {
  switch (+value) {
    case 0:
      return "待签署";
    case 1:
      return "已签署";
    case 2:
      return "无需签署";
    default:
      return null;
  }
};
const checkStCdTrans = function (value) {
  switch (+value) {
    case 0:
      return "审核中";
    case 1:
      return "审核通过";
    case 2:
      return "审核不通过";
    case 3:
      return "失效";
    default:
      return null;
  }
};
const epsCollTpCdTrans = function (value) {
  switch (value) {
    case "0":
      return "保理资信调查费";
    case "1":
      return "延期管理费";
    case "2":
      return "应收账款管理费";
    case "3":
      return "单据处理费";
    case "4":
      return "融资手续费";
    case "5":
      return "展期管理费";
    case "6":
      return "提前还款";
    case "7":
      return "交易手续费";
    case "8":
      return "交易安排费";
    case "9":
      return "交易安排费";
    case "10":
      return "交易安排费";
    case "11":
      return "信息服务费";
    case "12":
      return "技术服务费";
    default:
      return null;
  }
};
// 银行建档状态
const banktCdTrans = function (value) {
  switch (+value) {
    case 0:
      return "未提交";
    case 1:
      return "审核中";
    case 2:
      return "审核通过";
    case 3:
      return "审核不通过";
    case 4:
      return "信息异常";
    default:
      return null;
  }
};
const checkTypeFilter = function (value) {
  switch (value) {
    case "auto":
      return "自助查验";
    case "artificial":
      return "平台查验";
    default:
      return null;
  }
};
const invoiceTypeFilter = function (value) {
  switch (+value) {
    case 0:
      return "专用发票";
    case 1:
      return "电子专票";
    case 2:
      return "普通发票";
    case 3:
      return "电子普票";
    case 4:
      return "数电票";
    default:
      return null;
  }
};
const loanFlagEntries = function (value) {
  switch (value) {
    case "C":
      return "贷";
    case "D":
      return "借";
    default:
      return null;
  }
};
const dictFilter = function (value, list) {
  let item;
  if (isNaN(+value)) {
    item = list.find(i => i.value == value || i.dctVal == value);
  } else {
    item = list.find(i => +i.value == +value || +i.dctVal == +value);
  }
  if (item) {
    return item.name || item.dctValNm;
  }
  return null;
};
export default {
  dictFilter,
  docIdFilter,
  GbCbmTrans,
  GbGldStCdTrans,
  GbGldStCdTrans2,
  getNameFormList,
  pledgeStatus,
  goldTransferType,
  rpMdCdTrans,
  reqCptlTpCdTrans,
  tranType,
  signStCdTrans,
  checkStCdTrans,
  epsCollTpCdTrans,
  banktCdTrans,
  checkTypeFilter,
  invoiceTypeFilter,
  loanFlagEntries
};



// WEBPACK FOOTER //
// ./src/filters/page-filter.js